module.exports = __webpack_public_path__ + "img/PM-UNF.2019e297.svg";